import React, { ReactElement, FC } from "react"
import { Button } from '@mui/material'

import { ButtonSize, ButtonVariant } from '../constants/Button'


const ButtonComponent: FC<any> = (props: any): ReactElement => {

  const size = props.size || ButtonSize.MEDIUM
  const variant = props.variant || ButtonVariant.CONTAINED

  return (
    <Button
      {...props}
      size={size}
      variant={variant}
      onClick={() => {
        if ((props.disabled === false || props.disabled === undefined) && props.onClick !== undefined) {
          props.onClick()
        }
      }}
    >{props.children}</Button>
  )
}

export default ButtonComponent